<template>
    <div>
        <p class="interaction_p" v-if="chatItem.type=='joinWait'">新加入待接诊推送</p>
        <p class="interaction_p" v-if="chatItem.type=='consultationRenewal'">续费通知</p>
        <p class="interaction_p" v-if="chatItem.type=='comment'">医生发送点击评论</p>
        <p class="interaction_p" v-if="chatItem.type=='doctorApplyEnd'">医生申请结束服务</p>
        <p class="interaction_p" v-if="chatItem.type=='clientDisagreeEnd'">顾客拒绝结束服务</p>
        <p class="interaction_p" v-if="chatItem.type=='clientAgreeEnd'">顾客同意结束服务</p>
        <p class="interaction_p" v-if="chatItem.type=='clientEnd'">顾客主动结束服务</p>
        <p class="interaction_p" v-if="chatItem.type=='autoEnd'">咨询结束时间到自动服务</p>
    </div>

</template>

<style scoped>
    .interaction_p {
        font-size: 12px;
        color: #999999;
        text-align: center;
    }

    .m-5 {
        margin: 5px 0;
    }

    .img-wrap {
        display: flex;
        flex-wrap: wrap;
    }

    .image {
        margin: 3px;
    }

    img {
        width: 100px;
        height: 100px;
    }
</style>
<script>
    export default {
        props: {
            chatItem: {type: Object},
            userId: {type: String}
        },
        data() {
            return {
                create_date: '',
                describe: '',
                consultation_date: '',
                consultation_hospital: '',
                consultation_department: '',
                doctor_name: '',
                fileList: [],
            };
        },
        methods: {
            gethealthDetail(chatItem) {
                var message = JSON.parse(chatItem['message']['value']);
                this.create_date = message.create_date;
                this.describe = message.describe;
                this.consultation_date = message.consultation_date;
                this.consultation_hospital = message.consultation_hospital;
                this.consultation_department = message.consultation_department;
                this.doctor_name = message.doctor_name;
            },
            aaa () {

            }
        }
    };
</script>